import axios from "axios";
import { toast } from "react-toastify";
import { GET_APP_VERSIONINFO } from "../../../Store/Type";
const api = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});
const apiUrl = process.env.REACT_APP_API_URL;

export const getAppVersionInfo=async(dispatch)=>{
  try {
    const response = await axios.get(`${apiUrl}/getall/update/version`);
      console.log(response, "appversionnnnnnnnnnnnn");
      dispatch({
          type: GET_APP_VERSIONINFO,
          payload: response.data.appVersionData,
      });
  } catch (err) {
      console.log(err);
  }
}
export const AppVersionInfos=async(versionInfo)=>{
    const deviceID=versionInfo.device_type==="android"?2:4
      const payload = {
  mandatory_update: versionInfo.mandatory_update,
  app_url: versionInfo.app_url,
  device_type: versionInfo.device_type,
  device_id: deviceID,
  current_version: versionInfo.current_version,
  updated_version: versionInfo.updated_version,
      };
      const url=`${apiUrl}/store/mandatory/app/version`
      const method = "post";
      
      try {
        const response = await api({
          method,
          url,
          data:JSON.stringify(payload),
          headers: {
            "Content-Type": "application/json",
          },
        });
        console.log(response,"appversioninfos");
        
        toast.success(response.data.message)
        return response?.data
      } catch (error) {
        console.error('Error:', error);
      }
    
}